/**
 * WordPress dependencies
 */
export * from '@wordpress/html-entities';
